module.exports = __webpack_public_path__ + "static/media/Jermaime_2_Everyday Shirt.3467d791.jpeg";